import React from "react";
import Collapse from "@alboompro/boom-components/data-display/collapse";
import Icon from "@alboompro/boom-components/general/icon";
import styled, { css } from "styled-components";

export const Tooltip = styled.div`
  position: absolute;
  left: 100px;
  transform: translate(-50%, 90%);
  background-color: #595959;
  border-radius: 3px;
  text-align: center;
  padding: 4px 20px;
  min-width: 120px;
  max-width: 180px;
  color: #ffffff;
  font-size: 10px;
  letter-spacing: 0.4px;
  font-weight: 400;
  opacity: 0;
  pointer-events: none;
  z-index: 99;
  white-space: nowrap;
`;

export const IconQuestionWrapper = styled.div`
  margin-left: 10px;
  display: flex;

  img {
  width: 14px;
  cursor: pointer;
  }
  &:hover {
    ${Tooltip} {
    opacity: 1;
    transition: 0.2s opacity 0.3s cubic-bezier(0.55, 0.3, 0.5, 0.9);
    }
  }
`;

export const BorderedWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0 0 0 20px;
  margin: 0 0 0 15px;
  list-style: none;
  border-left: 1px dashed #b0b0b0;
`;

export const BorderedItem = styled.li`
  position: relative;

  &:before {
    content: "";
    display: block;
    position: absolute;
    left: -20px;
    top: 19px;
    width: 15px;
    border-bottom: 1px dashed #b0b0b0;
  }
  &:last-child {
    &:after {
      content: "";
      position: absolute;
      display: block;
      height: 100%;
      top: 19px;
      width: 2px;
      background-color: #f9f9f9;
      left: -21px;
    }
  }
`;

/**
 * Main style for collapse used in editor
 */
export const CollapseWrapper = styled(Collapse)`
  background-color: transparent;
  border: none;

  .panel {
    .header {
      padding: 10px 0;
      color: #696969;
      font-size: 14px;

      ${props => props.selector === "separator" && `
        padding: 12px 0 2px;
        cursor: default;
        font-weight: 500;
        text-transform: uppercase;
        font-size: 12px;
      `}
    }

    .body {
      background: transparent;
      border: none;
      padding: 0;
      overflow: visible;

      &.body-active {
        border-top: none;
      }

      .body-content-box {
        margin: 0;
        &:last-child {
          padding: 0 0 14px 0;
        }
      }
    }
  }

  &.group-separator {
    ${({ separatorPosition }) => {
      if(separatorPosition) {
        if(separatorPosition === "top") {
          return "border-top: 1px solid #ebebeb;"
        } if (separatorPosition === "bottom") {
          return "border-bottom: 1px solid #ebebeb;"
        } if(separatorPosition === "both") {
          return css`
            border-bottom: 1px solid #ebebeb;
            border-top: 1px solid #ebebeb;
          `
        }
      }
      return null;
    }}
  }
`;

/**
 * Wrapper for rotating icons inside collapse.
 */
export const IconWrapper = styled.div`
  transition: 0.1s ease-in-out;
  ${(props) =>
    props.open &&
    css`
      transform: rotate(180deg);
    `}
`;

export const expandIcon = (isActive) => {
  return (
    <IconWrapper open={isActive}>
      <Icon
        kind="bold"
        group="arrows-diagrams"
        category="arrows"
        file="arrow-button-down-2.svg"
        size="8"
        color="#696969"
      />
    </IconWrapper>
  );
};
